import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { X, UserCog } from 'lucide-react';
import AppContext from '../contexts/AppContext';
import { getName } from '../utils/userUtils';
import { endImpersonation } from '../utils/impersonation';

/**
 * Topbar notification shown while a super admin is impersonating another user.
 * Displays who is being impersonated and a cross to return to the original session.
 * Renders nothing when no impersonation session is active.
 */
const ImpersonationBanner = () => {
  const { t } = useTranslation();
  const { currentUser } = useContext(AppContext);

  if (!currentUser?.impersonatedBy) return null;

  const displayName = getName(currentUser.name || currentUser.email || '');

  return (
    <div className="flex items-center gap-2 rounded-full bg-amber-400 px-3 py-1 text-black shadow-sm">
      <UserCog className="h-4 w-4 shrink-0" />
      <span className="max-w-[40vw] truncate text-xs font-medium">
        {t('Logged in as {{name}}', { name: displayName })}
      </span>
      <button
        type="button"
        onClick={endImpersonation}
        title={t('Back to my account')}
        aria-label={t('Back to my account')}
        className="rounded-full p-0.5 transition-colors hover:bg-black/10"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default ImpersonationBanner;
